import { useState, useEffect } from 'react';
import { getStudioFeedsComments } from '@home/services/studio';

interface UseTrendingRequestParams {
  filter: any;
}

export const useStudioTrendingRequest = ({
  filter,
}: UseTrendingRequestParams) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({ list: [], total: 0 });
  const [error, setError] = useState(false);

  const fetchData = (extraFilter: any = {}) => {
    if (!filter?.edition_unified_id) return;
    setLoading(true);
    setData({ list: [], total: 0 });
    const params = {
      ...filter,
      page: 1,
      page_size: 4,
      exclude_translation: true,
      need_topic_translation: false,
      ...(extraFilter && Object.keys(extraFilter).length > 0
        ? { ...extraFilter }
        : {}),
    };
    getStudioFeedsComments(params).then((res: any) => {
      setData(res);
      setError(false);
      setLoading(false);
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  return { data, loading, error, refetch: fetchData };
};
